// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"3cc0eb5a","261":"48cbfd7d","266":"67001a9e","288":"ec61e943"}[chunkId] + ".chunk.css";
};